import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import Button from '../ui/Button';
import supabase from '../../supabase/supabase';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [session, setSession] = useState(null);
  const location = useLocation();

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'The Framework', path: '/safe-ai-framework' },
    { name: 'Work With Us', path: '/work-with-us' },
    { name: 'Resources', path: '/resources' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white sticky top-0 z-50 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20 md:h-24">
          <Link to="/" className="flex items-center">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/7c98abf852f963e06195176deed57bb9c81b4f53d205af5ca5b2f9af1b9cfaa840d35f6737e086b8644a3796bedcf0cc/images/aW1hZ2UvcG5n/51bb34f9956cf11fb97ebb2a9db89eac.png" 
              alt="AI CoLab Studio" 
              className="h-12 md:h-16 w-auto object-contain py-2 transition-transform hover:scale-105" 
            />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-5 xl:gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`text-[13px] xl:text-sm font-bold uppercase tracking-wider transition-colors whitespace-nowrap ${
                  isActive(link.path) ? 'text-brand-teal' : 'text-brand-navy hover:text-brand-teal'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="flex items-center gap-4 ml-4 pl-4 border-l border-gray-100">
              {session ? (
                <Link to="/library" className="flex items-center gap-2 text-brand-navy hover:text-brand-teal transition-colors font-bold text-xs uppercase tracking-wider">
                  <SafeIcon icon={FiIcons.FiUser} /> Library
                </Link>
              ) : (
                <Button to="/assessment" variant="primary" className="text-[10px] xl:text-xs py-2.5 px-4 font-bold uppercase tracking-widest leading-tight text-center">
                  Leadership Health Check
                </Button>
              )}
            </div>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="lg:hidden p-2 text-brand-navy"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <SafeIcon icon={isMenuOpen ? FiIcons.FiX : FiIcons.FiMenu} className="w-8 h-8" />
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 px-4 pt-4 pb-8 space-y-2 shadow-2xl absolute w-full left-0 right-0 animate-fade-in">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.path}
              className={`block px-4 py-4 rounded-xl text-lg font-bold uppercase tracking-tight ${
                isActive(link.path) ? 'bg-brand-teal/10 text-brand-teal' : 'text-brand-navy hover:bg-gray-50'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              {link.name}
            </Link>
          ))}
          {session && (
            <Link 
              to="/library" 
              className="block px-4 py-4 rounded-xl text-lg font-bold uppercase tracking-tight text-brand-navy hover:bg-gray-50"
              onClick={() => setIsMenuOpen(false)}
            >
              My Library
            </Link>
          )}
          <div className="pt-6 px-4">
            <Button to="/assessment" variant="primary" fullWidth onClick={() => setIsMenuOpen(false)} className="py-4 font-bold uppercase tracking-widest">
              AI Leadership Health Check
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;